// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Emoji_wrapper__3T7GA","size-lg":"Emoji_size-lg__10LtH","size-md":"Emoji_size-md__2qPJK","size-sm":"Emoji_size-sm__3-TkN"};